module.exports = __webpack_public_path__ + "static/img/zdgf_img.9281954.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zdgf_img.jpg
// module id = UNCY
// module chunks = 1